import req from '../api/https.js'

export const loveService ={
    create,
    find,
    findall, 
    deletelove,       
}
function create(obj){

    return req('post','/mylove/create',obj).then(rs=>{
        return rs
    }).catch(error =>{
        return Promise.reject(error);
    })    
}

function find(obj){
    return req('get', '/mylove/find/'+obj.id).then(rs=>{
        return rs
    }).catch(error=>{
        return Promise.reject(error)
    })
}

function findall(obj){
    return req('get', '/mylove/findall/'+obj.id).then(rs=>{
        return rs
    }).catch(error=>{
        return Promise.reject(error)
    })
}

function deletelove(id){
    return req('delete', '/mylove/deleteMyLove/'+id).then(rs=>{
        return rs.data
    }).catch(error=>{
        return Promise.reject(error)
    })
}
